<template>
  <!-- <div>
    Congratulation Your Transaction Was Successfull with Transaction Id {{this.$route.params.cartId}} <br> Total Amount Paid for the Transaction was {{this.$route.params.amount}}
    <div>
      <button>Print the Receipt</button>
    </div>
    <b-link class="btn btn-default-rounded ml-auto mr-2" :to="{ name: 'home'}">
      Go to Home
    </b-link>
  </div> -->
  <div class="success-pay">
    <!-- <headerLoginNoMenu></headerLoginNoMenu> -->
    <div class="bg-gray">
      <div class="row justify-content-center">
        <div class="col-md-7 col-sm-12">
          <div class="card">
            <!-- Transaction  info -->
            <div class="heading">
              <div class="row">
                <!-- <router-link to="home" class="link-css"> <a href="#"> <img src="/static/assets/images/livedemy-logo.png" alt="LOGO"></a></router-link> -->
                <div class="col text-left">
                  <span class="bal">INVOICE</span>
                <div class="date">Dated - {{new Date()|moment('DD-MM-YYYY')}}</div>
                  <!-- <span class="bal">Hi {{$store.getters.getProfileDetails.fullName}}!</span> -->
                
                </div>
                <div class="col text-right">
                   <span class="transaction"> Transaction ID: {{$route.params.transactionId}}</span>
                  <!-- <div>Dated: {{new Date()|moment('DD-MM-YYYY')}}</div> -->
                 
                </div>
              </div>
            </div>
            <br>
            <!-- item Purschased -->
            <ul v-for="(item,index) in itemsPurchased" :key="index">
              <li>
                <span> {{item.itemName}}  {{item.amount}} {{ item.amount>1 ?'POINTS':'POINT'}}</span>
              </li>
            </ul>
            <br>

            <!-- acknowledgement -->
            <div class="msg">
              <div v-if="this.$store.getters.getCartData.items.length !== 0 && this.$route.params.payementMode !== 'wallet' && this.$route.params.status === 'success'">
                <img v-if="isLoad" src="../../../static/assets/images/eclipse.gif" alt="">
              </div>
              <div class="content" v-if="$route.params.status === 'success' &&$route.params.payementMode==='wallet' ">{{$t('payment.labels.payment_receive')}} &nbsp;
                <span class="amt">
                  <i class="mdi mdi-currency-inr"></i>{{$route.params.amount}}</span>.
                <!--  <br/> Your wallet balance is updated and current wallet balance is &nbsp;
                <span class="amt">
                  <i class="mdi mdi-currency-inr"></i>{{0}}</span>-->
              </div>
              <div class="content" v-else-if="$route.params.status === 'success'">
                <span class="amt">
                  <i class="mdi mdi-currency-inr"></i>{{$route.params.amount}}</span>&nbsp; {{$t('payment.labels.credits_added')}}
                <!--  <br/> Your wallet balance is updated and current wallet balance is &nbsp;
                <span class="amt">
                  <i class="mdi mdi-currency-inr"></i>{{0}}</span>-->
              </div>
              <div class="content" v-else> {{$t('payment.labels.transaction_failed')}} &nbsp;
                <span class="amt">
                  <i class="mdi mdi-currency-inr"></i>{{$route.params.amount}}</span>.
                <!--  <br/> Your wallet balance is updated and current wallet balance is &nbsp;
                <span class="amt">
                  <i class="mdi mdi-currency-inr"></i>{{0}}</span>-->
              </div>

            </div>
            <div class="a-href" v-if="($route.params.payementMode==='wallet')">
              <b-link class="btn btn-large btn-purple" :to="{ name: 'profile'}">
                {{$t('payment.labels.go_to_profile')}}
              </b-link>
            </div>
            <div class="a-href" v-else-if="($route.params.payementMode!=='wallet'&& $route.params.status=='Failed')">
              <b-link class="btn btn-large btn-purple" :to="{ name: 'home'}">
                {{$t('payment.labels.go_to_home')}}
              </b-link>
            </div>
            <div class="a-href" v-else-if="($store.getters.getCartData.items.length==0)">
              <b-link class="btn btn-large btn-purple" :to="{ name: 'wallet'}">
                {{$t('payment.labels.go_to_wallet')}}
              </b-link>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="divider"></div> -->
    </div>
   
    <!-- <footerArea></footerArea> -->
  </div>
</template>

<script>
import footerArea from '../common/footerArea.vue'
// import headerLoginNoMenu from './common/headerLoginNoMenu.vue'
// import courseWishlist from '@/components/wishList/courseWishList.vue'
// import axios from 'axios'
export default {
  name: 'success',
  amount: 0,
  components: {
    footerArea
  },
  data () {
    return {
      profileId: this.$store.getters.getProfileDetails.profileId,
      isLoad: false,
      itemsPurchased: [],
      courseLength: 0,
      courseList: []
    }
  },
  created () {
    // not needed
    /*  for (var i = 0; i < this.$store.getters.getCourseEnrolled.length; i++) {
      if (this.$store.getters.getCourseEnrolled[i].courseType === 'CO') {
        this.courseList.push(this.$store.getters.getCourseEnrolled[i])
      }
    } */
    if (this.$route.params.payementMode === 'wallet') {
      // get Course data before purchase
      this.courseList = this.$store.getters.getItemsEnrolledByType('CO')
      /*
        steps:
        1.update cart
        2.fetch item purchased
        3.remove item from wishList those are purchased
      */
      // alert('here')
      this.$store.dispatch('viewCartData', this.$store.getters.getProfileDetails.profileId).then(
        response => {
          this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId).then(
            response => {
              for (let i = 0; i < this.$store.getters.getItemsEnrolledByType('ALL').length; i++) {
                for (let j = 0; j < this.$store.getters.getWishListStoreData.length; j++) {
                  if (this.$store.getters.getWishListStoreData[j].itemId === this.$store.getters.getItemsEnrolledByType('ALL')[i].contentId) {
                    this.$store.dispatch('removeWishListFromDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: this.$store.getters.getItemsEnrolledByType('ALL')[i].contentId }).then(
                      response => {
                        // console.log('removed')
                      },
                      error => {
                        console.log('Error in removing wishList from Db', error)
                      }
                    )
                  }
                }
              }
              // if course purchase then send info to ERA
              /* if (this.courseList.length !== this.$store.getters.getItemsEnrolledByType('CO').length) {
                return new Promise((resolve, reject) => {
                  axios
                    .post('r/sendERA', {
                      profileId: this.$store.getters.getProfileDetails.profileId,
                      cartId: this.$route.params.transactionId
                    })
                    .then(res => {
                      // console.log(res.data)
                      resolve()
                    })
                    .catch(err => {
                      console.log('Error Inserting Course To ERA', err)
                      reject()
                    })
                })
              } */
              /* if (this.courseList.length !== this.$store.getters.getCourseCOEnrolled.length) {
                axios
                  .post('r/sendERA', {
                    profileId: this.$store.getters.getProfileDetails.profileId,
                    cartId: this.$route.params.transactionId
                  })
                  .then(res => {
                    console.log(res.data)
                  })
                  .catch(err => {
                    console.log('Error Inserting Course To ERA', err)
                  })
              } */
            },
            error => {
              console.log('error in fetching course data', error)
            }
          )
          // bk 4 above
          /* this.$store.dispatch('fetchEnrolledCourses', this.$store.getters.getProfileDetails.profileId).then(
            response => {
              for (let i = 0; i < this.$store.getters.getCourseEnrolled.length; i++) {
                for (let j = 0; j < this.$store.getters.getWishListStoreData.length; j++) {
                  // console.log('cid', this.$store.getters.getCourseEnrolled[i].contentId)
                  // console.log('iid', this.$store.getters.getWishListStoreData[j].itemId)
                  if (this.$store.getters.getWishListStoreData[j].itemId === this.$store.getters.getCourseEnrolled[i].contentId) {
                    this.$store.dispatch('removeWishListFromDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: this.$store.getters.getCourseEnrolled[i].contentId }).then(
                      response => {},
                      error => {
                        console.log('Error in removing wishList from Db', error)
                      }
                    )
                  }
                }
              }
              if (this.courseList.length !== this.$store.getters.getCourseCOEnrolled.length) {
                axios
                  .post('r/sendERA', {
                    profileId: this.$store.getters.getProfileDetails.profileId,
                    cartId: this.$route.params.transactionId
                  })
                  .then(res => {
                    console.log(res.data)
                  })
                  .catch(err => {
                    console.log('Error Inserting Course To ERA', err)
                  })
              }
            },
            error => {
              console.log('error in fetching course data', error)
            }
          ) */
        },
        error => {
          console.log('error in removing cart data', error)
        }
      )
    }
  },
  mounted () {
    if (this.$store.getters.getCartData.items.length !== 0 && this.$route.params.payementMode !== 'wallet' && this.$route.params.status === 'success') {
      this.isLoad = true
      setTimeout(() => {
        this.$Progress.start()
        this.isLoad = false
        this.$router.push({ name: 'cart' })
      }, 5000)
    } else {
      if (this.$route.params.payementMode === 'wallet' && this.$route.params.status === 'success') {
        this.$store.dispatch('previousCartItems', {'profileId': this.profileId, 'cartId': this.$route.params.transactionId}).then(
          res => {
            this.itemsPurchased = res
          },
          err => {
            console.log('ERROR_IN_DISPLAYING_ITEM_PURCHASED : ', err)
          }
        )
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';

.success-pay {
  // background:linear-gradient(to right, #61bfee 0%, #af96fa 100%);
  // margin-top:-7px;
  .bg-gray {
    padding: 0 15px;
    background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
  }
  .a-href {
    a {
      color: #fff;
    }
  }
  .card {
    .heading {
      padding-bottom: 20px;
      font-weight: 600;
      .text-left {
        font-size: 28px;
        color: #45a7d8;
        font-weight: 700;
      }
      .transaction {
        font-size:16px;
        padding-top:15px;
        display: block;
          color: #3858ab;
      }
      .date{
        color:#333;
        font-size:14px;
        padding-top:40px;
        padding-bottom:20px;
      }
    }
    .msg {
      font-weight: 600;
      font-size: 18px;
      .content {
        padding-top: 20px;
        padding-bottom: 50px;
        line-height: 50px;
        .amt {
          font-size: 30px;
          display: inline-block;
          .fa {
            font-size: 30px;
            padding-right: 8px;
          }
        }
      }
    }
    .title {
      font-family: $opensans;
      padding-bottom: 20px;
      font-weight: 600;
      font-size: 18px;
      display: block;
    }
    // .fa {
    //   vertical-align: middle;
    //   font-size: 14px;
    //   padding-right: 10px;
    // }
    .bal {
      padding-top: 15px;
      color: #61bfee; /*non-webkit fallback*/
      line-height: 58px;
      font-size: 28px;
      background: -webkit-linear-gradient(80deg, #61bfee, #af96fa);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    border-radius: 3px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.18);
    border: none;
    background-color: #fff;
    transition: box-shadow 0.25s;
    margin: 50px 0;
    padding: 55px;
  }
}
@media screen and (max-width:500px){
  .success-pay {
    .card{
  padding:55px 30px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/cart/success.vue?6c04ceaa